import React from "react";
import get from "lodash/get";
import { compose } from "redux";
import { withPropsAndFragment as withProps } from "../../containers/wecompose";
import commonHocs from "../../routes/commonAsyncRouteHOCs";
import withListManager from "../../containers/withListManager";
import withLoginSignupModal from "../../containers/withLoginSignupModal";
import { with404ErrorWhen } from "../../containers/withFatalErrorWhen";
import withListInclusions from "../../containers/apollo/withListInclusions";
import RangePage from "../../components/pages/RangePage";
import useWork from "../../components/pages/RangePage/useWork";
import withArtistShopArtistInfo from "../../containers/apollo/withArtistShopArtistInfo";

const withWorkInfo = (Component) => {
  const WrappedComponent = (props) => {
    const workId = parseInt(get(props, "match.params.workId"), 10) || "";
    const locale = get(props, "userInfo.locale") || "en";
    const { work, loading: workLoading } = useWork({ workId, locale });
    return <Component {...props} work={work} workLoading={workLoading} />;
  };

  return WrappedComponent;
};

export default compose(
  commonHocs,
  withLoginSignupModal,
  withListInclusions,
  withListManager,
  withWorkInfo,
  withProps(({ userInfo, work }) => ({
    locale: get(userInfo, "locale"),
    artistName: get(work, "username"),
  })),
  withArtistShopArtistInfo,
  with404ErrorWhen(({ work, workLoading }) => {
    return !workLoading && !work;
  })
)(RangePage);
